import { render, staticRenderFns } from "./AssignmentScore.vue?vue&type=template&id=0739bc3a&"
import script from "./AssignmentScore.vue?vue&type=script&lang=js&"
export * from "./AssignmentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports